import { z } from "zod";

export function parseOrThrow<T extends z.ZodTypeAny>(
  schema: T,
  data: unknown,
  context: string,
): z.infer<T> {
  const result = schema.safeParse(data);
  if (!result.success) {
    console.group(`❌ [${context}] Validation failed`);
    console.error(
      "Schema issues:",
      JSON.stringify(result.error.format(), null, 2),
    );
    console.error("Actual data received:", JSON.stringify(data, null, 2));
    console.groupEnd();
    // In production, we might want to still return the data or a partial version
    // For now, let's just return the data cast to T if it's not a critical failure
    return data as z.infer<T>;
  }
  return result.data;
}
